export default __webpack_public_path__ + "static/media/logo.c2927c24.png";